import React from 'react'
import { Box, Typography } from '@mui/material'
import { Field, ErrorMessage } from 'formik'
import LearnMoreModal from './LearnMoreModal'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import RequestAttachmentUploader from './RequestAttachmentUploader'
import { CSVLink } from 'react-csv'
import AdxButton from 'components/custom/AdxButton'

const InviteMultipleStaffForm = ({ formikProps }) => {
  const { values, setFieldValue, handleSubmit, resetForm } = formikProps

  const CSVHeader = [['Name', 'Email', 'Designation', 'Department']]

  React.useEffect(() => {
    if (values.invite_staff_file) {
      handleSubmit()
    }
  }, [values]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: '200px',
        gap: 3,
        px: 0.5,
      }}
    >
      <Box>
        <Typography color="light-gray-text.main">
          Invite new employees by uploading csv file. This won’t overwrite existing employees
          information. Data that has error or already existed will not be uploaded.
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box>
          <Typography color="dark-gray-text.main">Step 1</Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'center',
            }}
          >
            <Typography mr={1} color="light-gray-text.main">
              Download the CSV template and fill in the necessary details.
            </Typography>
            <LearnMoreModal />
          </Box>
        </Box>
        <CSVLink
          filename={'EmployeeImportData.csv'}
          data={CSVHeader}
          style={{ textDecoration: 'none' }}
        >
          <AdxButton variant={'contained'} sx={{ width: 1 }}>
            Download CSV File
          </AdxButton>
        </CSVLink>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box>
          <Typography color="dark-gray-text.main">Step 2</Typography>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
            <Typography mr={1} variant="body2" color="light-gray-text.main">
              Upload filled CSV File
            </Typography>
          </Box>
        </Box>
        <Box>
          <Field name="invite_staff_file" values={values.invite_staff_file} type="hidden" />
          <RequestAttachmentUploader
            values={values}
            setFieldValue={setFieldValue}
            resetForm={resetForm}
            errorMessage={<ErrorMessage name="invite_staff_file" component={AdxErrorMessage} />}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default InviteMultipleStaffForm
